/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskType } from './TaskType';
import {
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
    TaskTypeToJSONTyped,
} from './TaskType';

/**
 * 
 * @export
 * @interface InputTask
 */
export interface InputTask {
    /**
     * 
     * @type {TaskType}
     * @memberof InputTask
     */
    taskType: TaskType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InputTask
     */
    taskParams: { [key: string]: any; };
}



/**
 * Check if a given object implements the InputTask interface.
 */
export function instanceOfInputTask(value: object): value is InputTask {
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (!('taskParams' in value) || value['taskParams'] === undefined) return false;
    return true;
}

export function InputTaskFromJSON(json: any): InputTask {
    return InputTaskFromJSONTyped(json, false);
}

export function InputTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputTask {
    if (json == null) {
        return json;
    }
    return {
        
        'taskType': TaskTypeFromJSON(json['task_type']),
        'taskParams': json['task_params'],
    };
}

export function InputTaskToJSON(json: any): InputTask {
    return InputTaskToJSONTyped(json, false);
}

export function InputTaskToJSONTyped(value?: InputTask | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_type': TaskTypeToJSON(value['taskType']),
        'task_params': value['taskParams'],
    };
}

